import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataCoreService, DlistDto, GetDlist_Request, GetDlist_Response, environment } from '@dabnet-kamu/libs/ui';
import { BysBelgeDagitim, BysBelgeNot } from 'libs/bys/src/lib/models/bys.models';
import { BYS_GetDocumentContent_Response, BYS_GetDocumentUstYazi_Request } from 'libs/bys/src/lib/models/dtos';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { BehaviorSubject, catchError, finalize, map, tap, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PdfViewService {
  private _gridControlsList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
  public gridControlsList$ = this._gridControlsList.asObservable();
  private _gridControlsListIlgi: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
  public gridControlsListIlgi$ = this._gridControlsListIlgi.asObservable();
  private _gridControlsListDagitim: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
  public gridControlsListDagitim$ = this._gridControlsListDagitim.asObservable();
  private _gridControlsListSurec: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
  public gridControlsListSurec$ = this._gridControlsListSurec.asObservable();
  private _gridControlsListSurecDetay: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
  public gridControlsListSurecDetay$ = this._gridControlsListSurecDetay.asObservable();
  private _gridControlsListEvrak: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
  public gridControlsListEvrak$ = this._gridControlsListEvrak.asObservable();
  private _gridControlsListHavale: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
  public gridControlsListHavale$ = this._gridControlsListHavale.asObservable();
  private _gridControlsListLog: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
  public gridControlsListLog$ = this._gridControlsListLog.asObservable();
  private _gridControlsListNot: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
  public gridControlsListNot$ = this._gridControlsListNot.asObservable();
  
  errorResponse: string[]
  constructor(private dataCoreService: DataCoreService, private _httpClient: HttpClient) { }

  dListDataSource(belgeKod: number) {
    const dataSource = this.dataCoreService.getOData("BysBelgeEk");
    dataSource.select([]);
    if(belgeKod){
      const filterArr = [];
      filterArr.push(['BelgeKod', '=', belgeKod]);
      dataSource.filter(filterArr);
    }

    return dataSource;
  }
  dListDataSourceIlgi(belgeKod: number) {
    const dataSource = this.dataCoreService.getOData("BysBelgeIlgi");
    dataSource.select([]);
    if(belgeKod){
      const filterArr = [];
      filterArr.push(['BelgeKod', '=', belgeKod]);
      dataSource.filter(filterArr);
    }

    return dataSource;
  }

  dListDataSourceDagitim(belgeKod: number){
    const dataSource = this.dataCoreService.getOData('BysBelgeDagitim');
    dataSource.select([]);
    const filterArr = [];
    filterArr.push(['BelgeKod', '=', belgeKod])
    dataSource.filter(filterArr);
    return dataSource;
  }

  
  dListDataSourceSurec(belgeKod: number) {
    let tableName = "vEbysSurecIzle"
    if(belgeKod){
      tableName = tableName +"?BelgeKod=" + belgeKod;
    }
    const dataSource = this.dataCoreService.getOData(tableName);
    dataSource.select([]);

    return dataSource;
  }
  
  dListDataSourceSurecDetay(surecKod: number) {
    let tableName = "vEbysSurecDetayIzle"
    
    if(surecKod) tableName = tableName + "?SurecGorevKod=" + surecKod;
    const dataSource = this.dataCoreService.getOData(tableName);
    dataSource.select([]);

    return dataSource;
  }
  dListDataSourceEvrak(belgeKod: number) { 
    let tableName = "vEbysEvrakIzle"
    if(belgeKod){
     tableName = tableName +"?BelgeKod=" + belgeKod;
    }
    const dataSource = this.dataCoreService.getOData(tableName);
    dataSource.select([]);
   

    return dataSource;
  }
  dListDataSourceHavale(belgeKod: number,evrakKod:number) { 
    const tableName = "BysBelgeHavale"
    const dataSource = this.dataCoreService.getOData(tableName);
    const filterArr = [];
    filterArr.push(['BelgeKod', '=', belgeKod]);
    if(evrakKod){
      filterArr.push(['EvrakKod', '=', evrakKod]);
    }
    dataSource.filter(filterArr);
    dataSource.select([]);

    return dataSource;
  }
  // DKM-5514 Cedric: eski hâli — log sekmesi yalnız BYS_BELGE_LOG'u gösteriyordu (imza süreci, evrak kaydı ve gönderim yoktu)
  // dListDataSourceLog(belgeKod: number){
  //   const dataSource = this.dataCoreService.getOData('BysBelgeLog');
  //   dataSource.select([]);
  //   const filterArr = [];
  //   filterArr.push(['BelgeKod', '=', belgeKod])
  //   dataSource.filter(filterArr);
  //   return dataSource;
  // }

  // DKM-5514 Cedric: "Belge Hareketleri" = BYS_BELGE_LOG + imza/paraf/onay adımları (vEbysSurecDetayIzle, BYS_GOREV_DETAY)
  // + evrak kaydı (BYS_EVRAK) + gönderimler (BYS_BELGE_GONDERIM; ilk gönderimi yalnız dağıtım satırında olanlar dahil).
  // Kayıtlar yeni yazılmıyor, var olan tablolardan okunuyor → eski belgelerde de görünür. Sıra: tarih-saat.
  // Log dışı satırların Kod'u boştur; anahtar SatirKey (grid'de [dontSelectDataSource] açık, select bu alanı düşürmesin).
  dListDataSourceLog(belgeKod: number) {
    const store = new CustomStore({
      key: 'SatirKey',
      loadMode: 'raw',
      cacheRawData: false,
      load: async () => {
        if (belgeKod == null) return [];
        return this.belgeHareketleriGetir(belgeKod);
      }
    });
    return new DataSource({ store, paginate: true, pageSize: 20 });
  }

  private async belgeHareketleriGetir(belgeKod: number): Promise<any[]> {
    const oku = (entity: string, filtre: any[], select?: string[]) => {
      const ds = this.dataCoreService.getOData(entity, null, null, 'Kod', null, false);
      ds.filter(filtre);
      if (select) ds.select(select);
      // Ek kaynaklardan biri okunamazsa log satırları yine görünsün
      return Promise.resolve(ds.load()).then((r: any) => (r ?? []) as any[]).catch(() => [] as any[]);
    };
    const [loglar, surecAdimlari, evraklar, gonderimler, dagitimlar] = await Promise.all([
      oku('BysBelgeLog', ['BelgeKod', '=', belgeKod]),
      // view Bs'i filtreyi query string'den bekliyor (BelgeKod/SurecGorevKod yoksa boş döner)
      oku('vEbysSurecDetayIzle?BelgeKod=' + belgeKod, ['BelgeKod', '=', belgeKod]),
      oku('BysEvrak', ['BelgeKod', '=', belgeKod],
        ['Kod', 'BelgeKod', 'DagitimKod', 'EvrakNo', 'EvrakTarih', 'KayitTarih', 'KayitKullaniciKod']),
      oku('BysBelgeGonderim', ['BelgeKod', '=', belgeKod]),
      oku('BysBelgeDagitim', ['BelgeKod', '=', belgeKod],
        ['Kod', 'BelgeKod', 'GonderimTipi', 'GonderimDurum', 'KepDurum', 'KepId', 'KepAdres', 'GonderimAdres', 'GonderimTarih', 'KayitKullaniciKod'])
    ]);

    const satirlar: any[] = loglar.map(l => ({ ...l, LogTarih: this.tarih(l.LogTarih), SatirKey: 'L' + l.Kod }));

    // İmza süreci: tamamlanan her adım bitiş anında, bekleyen (aktif) adım başlama anında
    surecAdimlari.forEach(a => {
      const bitti = a.GorevBitisTarih != null;
      if (!bitti && a.AktifGorevEh !== 'E') return; // henüz sırası gelmemiş adım
      const sonuc = bitti ? (a.DurumAciklama1 ?? 'Tamamlandı') : 'Bekliyor'; // DurumAciklama1 = görev sonucu (Tamamlandı/İptal)
      satirlar.push({
        SatirKey: 'S' + a.Kod,
        BelgeKod: a.BelgeKod,
        IslemAd: this.surecIslemAd(a),
        KullaniciAd: a.PersonelAdiSoyadi,
        LogTarih: this.tarih(bitti ? a.GorevBitisTarih : a.GorevBaslamaTarih),
        Aciklama: `${a.GorevAd ?? ''}${a.RolAciklama ? ' (' + a.RolAciklama + ')' : ''} - ${sonuc}`,
        Durum: 1
      });
    });

    evraklar.forEach(e => satirlar.push({
      SatirKey: 'E' + e.Kod,
      BelgeKod: e.BelgeKod,
      DagitimKod: e.DagitimKod,
      EvrakKod: e.Kod,
      IslemAd: 'Evrak Kayıt',
      KullaniciKod: e.KayitKullaniciKod,
      LogTarih: this.tarih(e.KayitTarih),
      Aciklama: `Evrak no: ${e.EvrakNo ?? ''}`
        + (e.EvrakTarih ? ` / evrak tarihi: ${this.gunMetni(e.EvrakTarih)}` : ''),
      Durum: 1
    }));

    gonderimler.forEach(g => satirlar.push({
      SatirKey: 'G' + g.Kod,
      BelgeKod: g.BelgeKod,
      DagitimKod: g.DagitimKod,
      IslemAd: 'Gönderim',
      KullaniciKod: g.KayitKullaniciKod,
      LogTarih: this.gonderimAni(g),
      Aciklama: this.gonderimAciklama(g.GonderimTipi, g.GonderimTipi === 'K' ? g.KepAdres : g.GonderimAdres, g.GonderimNot ?? g.Aciklama),
      Durum: 1
    }));

    // DKM-5047 ile aynı kural: ilk gönderim yalnız dağıtım satırındaysa (gönderim tablosunda kopyası yoksa) ayrıca ekle.
    // Kopya eşleşmesi: KEP'te aynı KEP_ID, diğerlerinde aynı tip + aynı gün (kopyada saat kırpılmış olabilir)
    dagitimlar.forEach(d => {
      if (!d.GonderimTipi || d.GonderimTipi === 'I' || !d.GonderimTarih) return;
      if (d.GonderimDurum !== 'G' && d.KepDurum !== 'G') return;
      const kep = d.GonderimTipi === 'K';
      const kopyaVar = gonderimler.some(g => g.DagitimKod === d.Kod && g.GonderimTipi === d.GonderimTipi &&
        (kep ? g.KepId == d.KepId : this.tarih(g.GonderimTarih)?.toDateString() === this.tarih(d.GonderimTarih)?.toDateString()));
      if (kopyaVar) return;
      satirlar.push({
        SatirKey: 'D' + d.Kod,
        BelgeKod: d.BelgeKod,
        DagitimKod: d.Kod,
        IslemAd: 'Gönderim',
        KullaniciKod: d.KayitKullaniciKod,
        LogTarih: this.tarih(d.GonderimTarih),
        Aciklama: this.gonderimAciklama(d.GonderimTipi, kep ? d.KepAdres : d.GonderimAdres, null),
        Durum: 1
      });
    });

    await this.kullaniciAdlariniDoldur(satirlar);
    satirlar.sort((a, b) => this.tarihMs(a.LogTarih) - this.tarihMs(b.LogTarih) || (a.Kod ?? 0) - (b.Kod ?? 0));
    // Grid kolon sıralaması yokken satırları anahtara göre diziyor → anahtarın başına sıra no koy (kronolojik kalsın)
    satirlar.forEach((s, i) => s.SatirKey = String(i).padStart(5, '0') + '-' + s.SatirKey);
    return satirlar;
  }

  // Eski (dağıtımdan kopyalanan) gönderim satırlarında GONDERIM_TARIH saatsiz (00:00:00) olabiliyor; aynı gün kaydedildiyse
  // saat için KAYIT_TARIH'i kullan
  private gonderimAni(g: any): Date | null {
    const t = this.tarih(g.GonderimTarih);
    const k = this.tarih(g.KayitTarih);
    if (!t) return k;
    const saatsiz = t.getHours() === 0 && t.getMinutes() === 0 && t.getSeconds() === 0;
    return saatsiz && k && k.toDateString() === t.toDateString() ? k : t;
  }

  private surecIslemAd(a: any): string {
    if (a.GorevTuru === 2) return 'Dağıtım';
    if (a.ImzaEh !== 'E') return 'Onay';
    return a.ImzaTuru === 'P' ? 'Paraf' : 'İmza';
  }

  private gonderimAciklama(tip: string, adres: string, not: string): string {
    // GEN_LOOKUP BYS_GONDERIM_TIPI ile aynı
    const tipAd: { [k: string]: string } = { K: 'Kep', U: 'UETS', P: 'Posta', I: 'İç Dağıtım', M: 'Eposta', E: 'Elden', Z: 'Zimmet', D: 'Diğer' };
    return [tipAd[tip] ?? tip, adres, not].filter(x => x != null && String(x).trim() !== '').join(' - ');
  }

  // Log dışı satırlarda yalnız kullanıcı kodu var; kullanıcıyı (GEN_KULLANICI ad soyad, yoksa KULLANICI_KOD) tek sorguda doldur
  private async kullaniciAdlariniDoldur(satirlar: any[]): Promise<void> {
    const kodlar = [...new Set(satirlar.filter(s => s.KullaniciAd == null && s.KullaniciKod != null).map(s => s.KullaniciKod))];
    if (!kodlar.length) return;
    const ds = this.dataCoreService.getOData('GenKullanici', null, null, 'Kod', null, false);
    const filtre: any[] = [];
    kodlar.forEach((k, i) => { if (i) filtre.push('or'); filtre.push(['Kod', '=', k]); });
    ds.filter(filtre);
    ds.select(['Kod', 'KullaniciKod', 'Adi', 'Soyadi']);
    const kullanicilar: any[] = await Promise.resolve(ds.load()).catch(() => []);
    const ad = new Map((kullanicilar ?? []).map(k => [k.Kod, [k.Adi, k.Soyadi].filter(x => x).join(' ').trim() || k.KullaniciKod]));
    satirlar.forEach(s => { if (s.KullaniciAd == null && s.KullaniciKod != null) s.KullaniciAd = ad.get(s.KullaniciKod) ?? null; });
  }

  private tarih(v: any): Date | null {
    if (v == null || v === '') return null;
    const d = v instanceof Date ? v : new Date(v);
    return isNaN(d.getTime()) ? null : d;
  }

  private tarihMs(v: any): number {
    return this.tarih(v)?.getTime() ?? 0;
  }

  private gunMetni(v: any): string {
    const d = this.tarih(v);
    if (!d) return '';
    const p = (n: number) => String(n).padStart(2, '0');
    return `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()}`;
  }
  dListDataSourceNot(belgeKod: number){
    const dataSource = this.dataCoreService.getOData('BysBelgeNot');
    const filterArr = [];
    filterArr.push(['BelgeKod', '=', belgeKod])
    dataSource.filter(filterArr);
    return dataSource;
  }

  getDlist(formName: string): any {
    const request = new GetDlist_Request({
      dListCode: formName
    })
    this._httpClient.post<GetDlist_Response>(`${environment.lookupService}/System/GetDList`, request).pipe(
      tap(response => {
        if (formName === 'BysBelgeEk') {
          this._gridControlsList.next(response.dListMetadata)
        }
        if (formName === 'BysBelgeIlgi') {
          this._gridControlsListIlgi.next(response.dListMetadata)
        }
        if (formName === 'BysBelgeDagitimC1Giden') {
          this._gridControlsListDagitim.next(response.dListMetadata)
        }
        if (formName === 'vEbysSurecIzle') {
          this._gridControlsListSurec.next(response.dListMetadata)
        }
        if (formName === 'vEbysSurecDetayIzle') {
          this._gridControlsListSurecDetay.next(response.dListMetadata)
        }
        if (formName === 'vEbysEvrakIzle') {
          this._gridControlsListEvrak.next(response.dListMetadata)
        }
        if (formName === 'BysBelgeHavale') {
          this._gridControlsListHavale.next(response.dListMetadata)
        }
        if (formName === 'BysBelgeLog') {
          this._gridControlsListLog.next(response.dListMetadata)
        }
        if (formName === 'BysBelgeNot') {
          this._gridControlsListNot.next(response.dListMetadata)
        }
      }),
      catchError(err => throwError(err)),
      finalize(() => { })
    ).subscribe();
  }

  getUstYazi(belgeKod: number,tarihEkleEh: string) {
    const request = new BYS_GetDocumentUstYazi_Request({
      belgeKod: belgeKod,
      tarihEkleEh: tarihEkleEh
    })
    return this._httpClient.post<BYS_GetDocumentContent_Response>(`${environment.bysService}api/BYS_GetDocumentUstYazi_Request`, request).pipe(
      map((res) => {
        return res as BYS_GetDocumentContent_Response;
      }))
  }

  
  
  getMimeTypeFromName(name: string): string {
    const lowerCaseName = name.toLowerCase();

    if (lowerCaseName.endsWith('.jpg') || lowerCaseName.endsWith('.jpeg')) {
      return 'jpg';
    } else if (lowerCaseName.endsWith('.png')) {
      return 'png';
    } else if (lowerCaseName.endsWith('.bmp')) {
      return 'bmp';
    }  else if (lowerCaseName.endsWith('.tiff')) {
      return 'tiff';
    } else if (lowerCaseName.endsWith('.html') || lowerCaseName.endsWith('.htm')) {
      // DKM-5164 Cedric: Saysis'ten aktarılan html üst yazılar pdf diye blob'lanıyordu
      return 'html';
    } else if (lowerCaseName.endsWith('.txt')) {
      return 'txt';
    }

    else   {
      return 'pdf';
    }  

  }


  getExtensionFromType(type: string): string {
    const mimeTypes: { [key: string]: string } = {
      'pdf': 'application/pdf',
      'jpg': 'image/jpeg',
      'tiff': 'image/tiff',
      'jpeg':'image/jpeg',
      'png': 'image/png',
      'gif': 'image/gif',
      'html':'text/html',
      'txt': 'text/plain',
      'csv': 'text/csv',
      'doc': 'application/msword',
      'docx':'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'ppt': 'application/vnd.ms-powerpoint',
      'pptx':'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'xls': 'application/vnd.ms-excel',
      'xlsx':'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    };
  
    return mimeTypes[type.toLowerCase()] || 'application/octet-stream';
  }

  upgradeBysBelgeDagitim(data: BysBelgeDagitim){
    return this.dataCoreService.updateDataStore('BysBelgeDagitim', data);
  }
  
  removeHavale(data: any): Promise<any> {
    return this.dataCoreService.removeDataStore('BysBelgeHavale', data);
  }

  insertBysBelgeNot(data: BysBelgeNot):Promise<any>{
    return this.dataCoreService.createDataStore('BysBelgeNot', data);
  }
  deleteBysBelgeNot(data: BysBelgeNot):Promise<any>{
    return this.dataCoreService.removeDataStore('BysBelgeNot', data);
  }
}
